import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge, getDefaultConfig } from "tailwind-merge";

const twMerge = extendTailwindMerge(() => {
  const config = getDefaultConfig();

  return {
    ...config,
    experimentalParseClassName: ({ className, parseClassName }) => {
      const parsed = parseClassName(className);
      const baseClassName = parsed.baseClassName.startsWith("tw-")
        ? parsed.baseClassName.slice(3)
        : parsed.baseClassName;

      return { ...parsed, baseClassName };
    }
  };
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
